<template>
    <div class="FiveCrowns">

        <v-layout row>

            <v-flex xs8>

                <div v-if="!noPlayers">

                    <div v-if="!noScores">

                        <table>
                            <thead>
                                <tr>
                                    <th><h1 class="display-2">Player</h1></th>
                                    <th>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</th>
                                    <th><h1 class="display-2">Score</h1></th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>

                                <tr :key="score.playerName" v-for="score in scores">
                                    <td><h1 class="display-2">{{score.playerName}}</h1></td>
                                    <td>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</td>
                                    <td><h1 class="display-2">{{score.playerScore}}</h1></td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <v-dialog v-model="addScoreDialog" max-width="30%" persistent>

                        <v-card>
                            <v-card-title class="headline">Enter {{ addScorePlayer }}'s Score for {{ currentRound }}</v-card-title>
                            <v-card-text>
                                <v-text-field ref="addScoreField" @keyup.enter.native="addPlayerScore" v-model="playerScore" label="Score"></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary" @click="addPlayerScore">Save Score</v-btn>
                                <v-btn color="danger" @click="resetGame">Reset Game</v-btn>
                            </v-card-actions>
                        </v-card>

                    </v-dialog>

                    <v-dialog v-model="gameIsOver" max-width="40%">

                        <v-card>
                            <v-card-title class="headline">Game Over</v-card-title>
                            <v-card-text>
                                <h1 class="display-2 text--primary">{{ winner }} Wins!</h1>



                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary" @click="resetGame">New Game</v-btn>
                            </v-card-actions>
                        </v-card>

                    </v-dialog>

                </div>


            </v-flex>

            <v-flex xs4>
                <h1 v-if="!gameIsOver" class="display-4 font-weight-medium">Round: <span style="font-size: 2em;">{{currentRound}}</span></h1>
            </v-flex>

        </v-layout>


        <v-dialog v-model="addPlayerDialog" max-width="30%" persistent>

            <v-card>

                <v-card-title class="headline">
                    Add Players
                </v-card-title>

                <v-card-text>
                    <v-text-field ref="addPlayerNameField" @keyup.enter.native="addPlayer" v-model="addPlayerName"
                                  label="Player Name">

                    </v-text-field>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" @click="addPlayer">Add Player</v-btn>
                    <v-btn color="success" @click="startGame">Start Game</v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "FiveCrowns",
        data() {
            return {
                addPlayerDialog: false,
                addPlayerName: '',
                addScoreDialog: false,
                addScorePlayer: null,
                playerScore: '',
                playerIndex: 0,
                gameOverDialog: false
            }
        },
        mounted() {

            if (this.noPlayers) {
                this.showAddPlayerDialog()
            }

        },
        computed: {
            currentRound() {
                return this.$store.getters['currentRound']
            },
            gameIsOver() {
                return this.currentRound === 'Game Over'
            },
            noPlayers() {
                return (this.$store.getters['players'].length < 1)
            },
            players() {
                return (this.$store.getters['players'])
            },
            noScores() {
                return (this.$store.getters['playerScores'].length < 1)
            },
            scores() {
                return this.$store.getters['playerScores']
            },
            winner() {

                let scores = this.$store.getters['playerScores']

                return scores[0].playerName

            },
            allPlayerScores() {

                let s = []

                this.players.forEach((playerName) => {
                    s.push(this.getScoresForPlayer(playerName))
                })
                return s

            }
        },
        methods: {
            startGame() {
                this.addPlayerDialog = false
                this.showAddScoreDialog()
            },
            showAddPlayerDialog() {
                this.addPlayerName = ''
                this.addPlayerDialog = true
                this.$nextTick(this.$refs.addPlayerNameField.focus)
            },
            addPlayer() {
                if (this.addPlayerName !== '') {
                    let newPlayer = this.addPlayerName
                    this.$store.dispatch('addPlayer', newPlayer).then(() => this.addPlayerName = '')
                }
            },
            showAddScoreDialog() {

                this.playerIndex = 0
                this.addScorePlayer = this.players[0]
                this.addScoreDialog = true
                this.playerScore = ''

                this.$nextTick(this.$refs.addScoreField.focus)

            },
            nextPlayer() {

                this.playerIndex++
                this.addScorePlayer = this.players[this.playerIndex]
                this.playerScore = ''

            },
            firstPlayer() {

                this.playerIndex = 0
                this.addScorePlayer = this.players[0]
                this.playerScore = ''

            },
            addPlayerScore() {

                this.$store.dispatch('addScore', {
                    playerName: this.addScorePlayer,
                    score: this.playerScore
                }).then(() => {

                    this.nextPlayer()

                    if (typeof this.players[this.playerIndex] === 'undefined') {

                        this.firstPlayer()

                        this.$store.dispatch('nextRound').then(() => {

                            if (this.currentRound === 'Game Over') {
                                this.showGameOverDialog()
                            }

                        })

                    }

                })

            },
            showGameOverDialog() {

                this.addScoreDialog = false
                this.gameOverDialog = true

            },
            resetGame() {

                this.$store.dispatch('resetGame')
                this.gameOverDialog = false
                this.showAddScoreDialog()

            },
            getScoresForPlayer(playerName) {

                return this.$store.getters['rawScores'].filter((score) => score.playerName === playerName)

            }
        }
    }
</script>